var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"layout"},[_c('app-nav'),_c('el-container',{staticClass:"main",attrs:{"direction":"vertical"}},[_c('app-header'),_c('el-main',{staticClass:"body"},[_c('router-view')],1),_c('el-footer',{staticClass:"footer"},[_vm._v(" Copyright © 2018 - "+_vm._s(_vm.year)+" 超星 ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }